import { Component } from '@theme/component';

class ReadMore extends Component {
  requiredRefs = ['readMoreButton'];

  connectedCallback() {
    super.connectedCallback();

    this.refs.readMoreButton?.addEventListener('click', () => {
      const selector = this.getAttribute('target');

      if (!selector) return;

      const target = document.querySelector(selector);

      if (!target) return;

      // Adjust this selector if your theme uses a different header class
      const header = document.querySelector('.header');
      const headerHeight = header ? header.offsetHeight : 0;

      const top =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        headerHeight -
        16; // optional spacing

      window.scrollTo({
        top,
        behavior: 'smooth',
      });
    });
  }
}

if (!customElements.get('read-more')) {
  customElements.define('read-more', ReadMore);
}